import { Market } from '../../runtypes/MarketRuntype';
import { SelectedMarketDatesArrayRuntype } from '../../runtypes/SelectedMarketDatesRuntype';

type MarketSubset = Pick<Market, 'id' | 'dates' | 'name'>;

export type SelectedMarketDatesMap = Map<
  MarketSubset['id'],
  {
    selectedDates: Set<string>;
    market: MarketSubset;
  }
>;

export function getEmptySelectedMarketDates(
  markets: Array<MarketSubset>,
): SelectedMarketDatesMap {
  return new Map(
    markets.map((market) => {
      return [market.id, { selectedDates: new Set(), market }];
    }),
  );
}

export function stringifySelectedMarketDates(
  selectedMarketDates: SelectedMarketDatesMap,
): string {
  const selectedMarketDatesArray = Array.from(selectedMarketDates).map(
    ([key, value]) => {
      const { selectedDates, market } = value;
      const newValue = { selectedDates: Array.from(selectedDates), market };
      return [key, newValue];
    },
  );
  const stringifiedSelectedMarketDates = JSON.stringify(
    selectedMarketDatesArray,
  );
  return stringifiedSelectedMarketDates;
}

export function parseStringifiedSelectedMarketDates(
  stringifiedSelectedMarketDates: string,
): SelectedMarketDatesMap {
  const parsedSelectedMarketDatesArray = JSON.parse(
    stringifiedSelectedMarketDates,
  );
  if (!SelectedMarketDatesArrayRuntype.guard(parsedSelectedMarketDatesArray)) {
    return new Map();
  }
  const selectedMarketDatesEntries = parsedSelectedMarketDatesArray.map(
    ([key, value]) => {
      const newValue = {
        ...value,
        selectedDates: new Set(value.selectedDates),
      };
      return [key, newValue] as const;
    },
  );
  return new Map(selectedMarketDatesEntries);
}
